// @flow
import { TEASER_CARDS } from 'Client/cms/toolkit/constants';
import { TeaserCardsLine } from 'Components/lines/teaser-cards-line/TeaserCardsLine.jsx';
import { teaserCardsResolver } from './teaserCards.resolver';

export const teaserCardsDescriptor = {
  name: TEASER_CARDS,
  component: TeaserCardsLine,
  resolve: teaserCardsResolver.resolve,
};
